/*
  src/redux/loyalty/reducer.js

  Created by Justin Chang on 5/16/2017
*/

import update from '../update';

import {
  SET_CARD_NUMBER,
  SET_CARD_AMOUNT,
  SET_BUFFER_AMOUNT,
  SET_GOAL_AMOUNT,
  SET_LIFETIME_AMOUNT,
  SET_CARD_HAS_COUPON,
  SET_ALL_CARD_DATA,
  SET_COUPON_EXPIRATION_DATE
} from './constants';

const initialState = {
  cardNumber:     null,
  cardAmount:     0,
  bufferAmount:   0,
  goalAmount:     1,
  lifetimeAmount: 0,
  couponExpirationDate: null,
};

const loyaltyReducer = (state=initialState, action) => {
  switch (action.type) {

    case SET_CARD_NUMBER:
      return update(state, {
        cardNumber: {$set: String(action.payload)}
      });

    case SET_CARD_AMOUNT:
      return update(state, {
        cardAmount: {$set: action.payload || 0}
      });

    case SET_BUFFER_AMOUNT:
      return update(state, {
        bufferAmount: {$set: action.payload || 0}
      });

    case SET_GOAL_AMOUNT:
      return update(state, {
        goalAmount: {$set: action.payload || 0}
      });

    case SET_LIFETIME_AMOUNT:
      return update(state, {
        lifetimeAmount: {$set: action.payload}
      });

    case SET_CARD_HAS_COUPON:
      return update(state, {
        hasCoupon: {$set: action.payload}
      });

    case SET_COUPON_EXPIRATION_DATE:
      return update(state, {
        couponExpirationDate: {$set: action.payload}
      });

    // Take any card data passed to action
    case SET_ALL_CARD_DATA:
      return update(state, {
        $set: {
          cardNumber:     action.payload.cardNumber     || state.cardNumber,
          cardAmount:     action.payload.cardAmount     || state.cardAmount,
          bufferAmount:   action.payload.bufferAmount   || state.bufferAmount   || 0,
          goalAmount:     action.payload.goalAmount     || state.goalAmount     || 0,
          lifetimeAmount: action.payload.lifetimeAmount || state.lifetimeAmount || 0,
          couponExpirationDate: action.payload.couponExpirationDate || state.couponExpirationDate,
        }
      });

    default:
      return state;
  }
}

export default loyaltyReducer;



// WEBPACK FOOTER //
// ./src/redux/loyalty/reducer.js